import { Link } from 'react-router-dom';
import { mangaList, latestMangaIds } from '@/mocks/manga';

export default function LatestUpdateSection() {
  const latestManga = latestMangaIds
    .map((id) => mangaList.find((m) => m.id === id))
    .filter(Boolean) as typeof mangaList;

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            <strong>最新更新</strong>韩漫
          </h2>
          <p className="text-sm text-foreground-500 mt-1">每日更新，第一时间阅读最新章节</p>
        </div>
        <Link
          to="/category/all"
          className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
        >
          查看全部 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="space-y-3" data-product-shop>
        {latestManga.map((manga) => {
          const latestChapter = manga.chapters[manga.chapters.length - 1];
          return (
            <Link
              key={manga.id}
              to={`/article/${manga.id}`}
              className="flex items-center gap-4 p-4 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/30 transition-all cursor-pointer group"
            >
              <div className="w-16 h-20 md:w-20 md:h-24 flex-shrink-0 rounded-lg overflow-hidden">
                <img
                  src={manga.cover}
                  alt={manga.title}
                  title={`${manga.title} - 韩漫漫画网`}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                    {manga.title}
                  </h3>
                  <span className="px-2 py-0.5 bg-accent-100 text-accent-700 text-xs rounded-full font-medium whitespace-nowrap">
                    {manga.category === 'romance' ? '恋爱' : manga.category === 'action' ? '动作' : manga.category === 'fantasy' ? '奇幻' : manga.category === 'drama' ? '剧情' : manga.category === 'thriller' ? '悬疑' : manga.category === 'horror' ? '恐怖' : manga.category === 'comedy' ? '喜剧' : '都市'}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 mt-1 line-clamp-1">{manga.author}</p>
                <div className="flex items-center gap-2 mt-1.5 flex-wrap">
                  <span className="text-xs text-foreground-500">
                    <i className="ri-eye-line mr-0.5"></i>
                    {manga.views >= 10000 ? `${(manga.views / 10000).toFixed(0)}万` : manga.views}
                  </span>
                  <span className="text-xs text-foreground-400">|</span>
                  <span className="text-xs text-foreground-500">
                    <i className="ri-star-line mr-0.5"></i>
                    {manga.rating}
                  </span>
                  <span className="text-xs text-foreground-400">|</span>
                  <span className="text-xs text-foreground-500">
                    <i className="ri-chat-3-line mr-0.5"></i>
                    {manga.chapters.length}话
                  </span>
                </div>
              </div>

              <div className="hidden sm:flex flex-col items-end gap-1 flex-shrink-0">
                <span className="text-xs text-accent-600 font-medium whitespace-nowrap">
                  更新至 {latestChapter?.number} 话
                </span>
                <span className="text-xs text-foreground-400 whitespace-nowrap">{manga.updateDate}</span>
              </div>

              <div className="flex-shrink-0">
                <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors text-xl"></i>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}